import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { flutterBridge } from '@/bridge/flutter-bridge'

/**
 * Hook to handle navigation when user taps on a push notification
 * Routes to appropriate screen based on notification data
 */
export function useNotificationNavigation() {
  const navigate = useNavigate()

  useEffect(() => {
    // Only run in Flutter WebView
    if (!flutterBridge.isInFlutter) return

    const unsubscribe = flutterBridge.onEvent('pushNotificationTapped', (data) => {
      const action = data.action as string | undefined
      const activityId = data.activityId as string | undefined
      const screen = data.screen as string | undefined

      switch (action) {
        case 'open_activity':
          if (activityId) {
            navigate(`/activity/${activityId}`)
          }
          break

        case 'open_subscription':
          navigate('/subscription')
          break

        case 'open_reminder':
          if (activityId) {
            navigate(`/activity/${activityId}?reminder=true`)
          }
          break

        case 'open_screen':
          if (screen) {
            navigate(`/${screen}`)
          }
          break

        default:
          // Default: navigate to home
          navigate('/')
      }
    })

    return () => {
      unsubscribe()
    }
  }, [navigate])
}
